module.exports = __webpack_public_path__ + "img/03.1a26214a.jpg";